import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

export default function HeroSection() {
  return (
    <div>
      {/* Hero Section */}
      <section className="text-center py-12 px-2 md:px-4 max-w-4xl mx-auto relative">
        <div className="text-4xl md:text-6xl mb-4 absolute top-[20%] lg:top-[25%] left-[1rem] lg:left-[-5rem] animate-blink">
          ✨
        </div>
        <div className="text-4xl md:text-6xl mb-4 absolute top-[20%] lg:top-[25%] right-[1rem] lg:right-[-5rem] animate-blink">
          ✨
        </div>

        <motion.h1
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="text-4xl md:text-6xl font-bold mb-3 lg:mb-6 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-yellow-400"
        >
          AstroLogical
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
          className="text-xl md:text-2xl font-semibold mb-4 text-purple-200"
        >
          Forum &amp; Kundli
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
          className="text-[12px] md:text-[14px] text-[var(--light-purple)] mb-8 max-w-2xl mx-auto leading-relaxed"
        >
          Discover your cosmic blueprint with personalized Kundli, compatibility
          analysis, daily predictions, and expert consultations. Your journey
          into Vedic wisdom starts here.
        </motion.p>

        {/* <div className="relative mb-12">
          <div className="text-6xl md:text-8xl mb-4 animate-pulse">✨</div>
          <div className="flex justify-center space-x-4 text-3xl">
            <span className="animate-bounce delay-100">🌙</span>
            <span className="animate-bounce delay-200">⭐</span>
            <span className="animate-bounce delay-300">🌟</span>
            <span className="animate-bounce delay-400">🪐</span>  
            <span className="animate-bounce delay-500">☀️</span>
          </div> 
        </div> */}

        {/* CTA Buttons with animation */}
        <div className="flex  justify-center items-center gap-[10px] md:gap-4">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <NavLink
              to="/kundli"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-[13px] md:text-[15px] ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-primary hover:bg-primary/90 h-11 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold px-10 py-3 rounded-full"
            >
              🌙 Create <span className="hidden md:flex">Your</span> Kundli
            </NavLink>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            <NavLink
              to="/shubh-muhurat"
              className="flex items-center justify-center gap-2 bg-white text-[13px] md:text-[15px] text-gray-700 font-medium  rounded-full shadow-lg hoverGetDaily transition-all duration-200 px-8 py-[12px]"
            >
              View Full Choghadiya
            </NavLink>
          </motion.div>
        </div>

        {/* Quote Section */}
        <section className="text-center text-yellow-300 italic text-lg mb-6 px-4 hidden">
          <div className="mt-16 p-6 bg-slate-800/50 rounded-2xl border border-purple-500/20 backdrop-blur-sm">
            <p className="text-lg text-yellow-300 font-serif italic mb-2">
              "सर्वं खल्विदं ब्रह्म"
            </p>
            <span className="text-purple-300 text-sm">
              "All this is indeed Brahman" - The cosmic consciousness pervades
              everything
            </span>
          </div>
        </section>
      </section>
    </div>
  );
}
